export const preview = {
  config: [
    {
      id: 'name',
      label: 'Name',
      fieldType: 'text',
    },
    {
      id: 'category',
      label: 'Category',
      fieldType: 'text',
    },
  ],
};
